<template>
    <div class="ui-modal">
        <div class="ui-modal-backdrop" />
        <div
            v-body-lock="true"
            class="ui-modal-wrapper"
        >
            <div
                v-click-outside="isCloseOnClickOutside"
                class="ui-modal-component"
            >
                <div class="ui-modal-header">
                    <UIButton
                        v-if="!permanent"
                        flat
                        class="ui-modal__close"
                        @click="$emit('close')"
                    >
                        <template #icon>
                            <CloseSvg />
                        </template>
                    </UIButton>
                </div>
                <div class="ui-modal-content">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import {UIButton} from '@cibsite/ui-components-vue2';

import bodyLock from '@/core/directives/bodyLock';
import CloseSvg from '@/assets/images/icons/close.svg?inline';

export default defineComponent({
    name: 'UIModal',
    components: {
        CloseSvg,
        UIButton,
    },
    directives: {
        'body-lock': bodyLock,
    },
    props: {
        permanent: {
            type: Boolean,
            default: () => false,
        },
        closeByClick: {
            type: Boolean,
            default: () => false,
        },
    },
    setup(props, context) {
        function isCloseOnClickOutside() {
            if (props.permanent || props.closeByClick) {
                return;
            }

            context.emit('close');
        }

        return {
            isCloseOnClickOutside,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/ui-elements/ui-modal';
</style>
